// Vendor Imports
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Project Imports
import { setMeasureAxisPrecision } from 'common/authoring_workflow/actions';
import {
  getMeasureAxisPrecision,
  isLogarithmicScale,
} from 'common/authoring_workflow/selectors/vifAuthoring';
import PrecisionSelector from '../../shared/PrecisionSelector';
import { AuthoringWorkflowState } from 'common/authoring_workflow/reducers/types';

export const AxisPrecisionSelectorSingle = () => {
  const dispatch = useDispatch();
  const vifAuthoring = useSelector((state: AuthoringWorkflowState) => state.vifAuthoring);

  const customPrecisionDisabled = isLogarithmicScale(vifAuthoring);
  const precision = getMeasureAxisPrecision(vifAuthoring);

  const onSetMeasureAxisPrecision = (precisionValue?: number) => {
    dispatch(setMeasureAxisPrecision(precisionValue));
  };

  return (
    <PrecisionSelector
      id="measure-axis-precision"
      className="measure-axis-precision-container"
      customPrecisionDisabled={customPrecisionDisabled}
      precision={precision}
      onSetPrecision={onSetMeasureAxisPrecision}
    />
  );
};
